import PropTypes from 'prop-types';
import {
    HAIR_STYLES_PREFERENCES,
    HAIR_COLORS_PREFERENCES,
} from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJLocalStore from '../../../../../store/FJLocalStore';
import OptionCard from '../OptionCard';
import FJNoChangeIcon from '../../../../../assets/svg/no-change.svg?react';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJImage from '../../../../../common/components/FJImage/FJImage';
import FJToolTip from '../../../../../common/components/FJToolTip/FJToolTip';

import commonStyles from './StepForm.module.less';
import styles from './FJHairPreferenceSelector.module.less';
import { useMemo } from 'react';
import { useCallback } from 'react';
import FJConfig from '../../../../../config/FJConfig';
import FJHeadshotHairColorPicker from './FJHeadshotHairColorPicker';
import FJFileHandleUtil from '../../../../../util/FJFileHandleUtil';

const presetHairColor = HAIR_COLORS_PREFERENCES.slice(0, 5);

const FJHairPreferenceSelector = ({
    selectedHairPreferences,
    onHairPreferencesChange,
    gender,
    hairColorNewOption,
    setHairColorNewOption,
}) => {
    const handleStyleChange = useCallback(
        style => {
            const newPreferences = { ...selectedHairPreferences, style };
            onHairPreferencesChange(newPreferences);
        },
        [selectedHairPreferences, onHairPreferencesChange],
    );

    const handleColorChange = useCallback(
        color => {
            // REQUIREMENT: 需要展示新的选项到前面，并且只展示一个新的
            const newPreferences = { ...selectedHairPreferences, color };
            if (color && !presetHairColor.some(item => item.key === color.key) && color.key !== 'no-change') {
                setHairColorNewOption(HAIR_COLORS_PREFERENCES.find(item => item.key === color.key));
            }
            onHairPreferencesChange(newPreferences);
        },
        [selectedHairPreferences, onHairPreferencesChange, setHairColorNewOption],
    );

    const currentHairStyleOptions = useMemo(() => {
        return HAIR_STYLES_PREFERENCES.filter(style => style.gender === gender);
    }, [gender]);

    const hairColorDisplayList = useMemo(() => {
        if (hairColorNewOption) {
            return [hairColorNewOption, ...presetHairColor];
        } else {
            return presetHairColor;
        }
    }, [hairColorNewOption]);

    return (
        <div className={commonStyles.step_form}>
            <h3 className={commonStyles.step_title}>{FJLocalStore._('hair-length-and-color')}</h3>

            <div className={commonStyles.options_grid} style={{ marginBottom: 50 }}>
                {currentHairStyleOptions.map(style => (
                    <OptionCard
                        key={style.key}
                        onClick={() => handleStyleChange(style.value)}
                        title={FJLocalStore._(style.key)}
                        isSelected={selectedHairPreferences.style === style.value}
                        imageUrl={FJFileHandleUtil.getImageUrlWithFormat(
                            `${FJConfig.headshotImagePath}${style.imageUrl}?v=${FJConfig.version}`,
                        )}
                    >
                        <div className={commonStyles.option_description}>{style.key}</div>
                    </OptionCard>
                ))}
            </div>

            <div className={styles.hair_color_flex}>
                <span className={styles.color_title}>{FJLocalStore._('hair-color')}</span>
                <div className={styles.hair_color_no_change}>
                    <FJHoverBoardGradation
                        key='no-change'
                        className={styles.hover_board_box}
                        active={selectedHairPreferences.color.value === 'no-change'}
                        onClick={() =>
                            handleColorChange({
                                key: 'no-change',
                                value: 'no-change',
                            })
                        }
                        borderRadius={25}
                        isShowInBorder
                    >
                        <FJToolTip title={FJLocalStore._('no-change')}>
                            <div id='no-change' className={styles.no_change_icon}>
                                <FJNoChangeIcon />
                            </div>
                        </FJToolTip>
                    </FJHoverBoardGradation>
                </div>
                {hairColorDisplayList.map(color => (
                    <FJHoverBoardGradation
                        key={color.key}
                        className={styles.hover_board_box}
                        active={selectedHairPreferences.color.value === color.value}
                        onClick={() => handleColorChange(color)}
                        borderRadius={25}
                        isShowInBorder
                    >
                        <FJToolTip title={FJLocalStore._(color.key)}>
                            <div>
                                <FJImage
                                    imgSrc={FJConfig.hairColorImagePath + color.imageUrl + `?v=${FJConfig.version}`}
                                    alt={color.key}
                                    imgClassName={styles.option_image}
                                    boxClassName={styles.option_image_box}
                                    onRefresh={() => handleColorChange(color)}
                                    isShowLoading
                                />
                            </div>
                        </FJToolTip>
                    </FJHoverBoardGradation>
                ))}
                <div className={styles.hair_color_more}>
                    <FJHeadshotHairColorPicker onSelect={handleColorChange} value={selectedHairPreferences.color} />
                </div>
            </div>
        </div>
    );
};

FJHairPreferenceSelector.propTypes = {
    selectedHairPreferences: PropTypes.object,
    onHairPreferencesChange: PropTypes.func,
    gender: PropTypes.string,
    hairColorNewOption: PropTypes.object,
    setHairColorNewOption: PropTypes.func,
};

export default FJHairPreferenceSelector;
